import { __read } from "tslib";
import React from 'react';
import ReactDOM from 'react-dom';
import { FaTimes } from 'react-icons/fa';
var overlayWrapperStyle = {
    position: 'fixed',
    width: '95vw',
    height: '100vh',
    background: 'white',
    top: 0,
    right: 0,
    boxShadow: '-7px -2px 6px -3px rgba(209,209,209,1)',
    overflowX: 'auto',
    zIndex: 9,
    maxWidth: '1200px',
};
export var Overlay = function (props) {
    var isShowing = props.isShowing, hide = props.hide, children = props.children, hideHeader = props.hideHeader;
    var node = React.useRef(null);
    var _a = __read(React.useState(false), 2), hideIsTriggered = _a[0], setHideIsTriggered = _a[1];
    React.useEffect(function () {
        // add when mounted
        document.addEventListener('keydown', onKeyPressed);
        document.addEventListener("mousedown", handleClickOutside);
        // return function to be called when unmounted
        return function () {
            document.removeEventListener('keydown', onKeyPressed);
            document.removeEventListener("mousedown", handleClickOutside);
        };
    });
    var handleClickOutside = function (e) {
        if (node && node.current && node.current.contains(e.target)) {
            return;
        }
        if (node && node.current && e.target.classList.contains('ignore-clickoutside')) {
            return;
        }
        // outside click
        if (props.isShowing) {
            props.hide && props.hide();
        }
    };
    var onKeyPressed = function (e) {
        if (e.key === 'Escape' && props.hide && props.isShowing) {
            e.preventDefault();
            props.hide();
        }
    };
    var level = props.level || 1;
    return ReactDOM.createPortal(React.createElement(React.Fragment, null,
        React.createElement("div", { className: "take-over" + (isShowing ? ' is-showing' : '') + (hideHeader ? ' hide-header' : '') + ' level-' + level, ref: node },
            React.createElement("div", { onClick: hide, className: "take-over__close" },
                React.createElement(FaTimes, null)),
            React.createElement(React.Fragment, null, children && children))), document.getElementById('root'));
};
//# sourceMappingURL=Overlay.js.map